import * as React from 'react';
import { Link } from 'gatsby';

// @ts-ignore
import logo from '../images/s4ten-logo.png';

const Header = () => (
  <header className="border-b-8 border-theme-red h-32 flex items-center justify-between px-8">
    <Link
      to="/"
      className="h-full flex items-center text-theme-red font-heading text-5xl"
    >
      <img src={logo} style={{ height: 115 }} alt="Starter4Ten Logo" />
      <span className="pl-2">Starter4Ten</span>
    </Link>
  </header>
);

export default Header;
